export default (reducers, state, action) => {
    if (!reducers[action.type]) return state;

    return reducers[action.type](state, action);
};
